import React, { Fragment } from "react";
import i4 from "../../Assets/Image/i4.png";
import "../../Assets/Scss/Login_Page.scss";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { payrollActions } from "../../store";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch } from "react-redux";
import ImgIllustrate from "../../Assets/Image/login_illustrate.jpg";
import logo from "../../Assets/Image/white_logo.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import "swiper/css/navigation";
import Illustrate from "../../Assets/Image/Illustrate.png";

// import "./styles.css";
import { Autoplay, Pagination } from "swiper";
import LoginDetail from "./Components/Login_Details.jsx";
import ChangePassword from "./Components/ChangePWD";
import SetUpDetailPage from "../SetUpPage/Set_Up_Login";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  boxShadow: 24,
  borderRadius: "5px",
  outLine: "none",
  p: 4,
};
const Title_Style = {
  fontWeight: 500,
  fontSize: "22px",
  lineHeight: "120%",
  textAlign: "center",
  color: "red",
};

const LogInPage = () => {
  const dispatch = useDispatch();
  const step = useSelector((state) => state.payroll.Step);
  // const step =2

  return (
    <Fragment>
      <div className="Login_Fill">
        <div className="Left">
          <img src={logo} alt="avatar" />
          <div className="Content_Box">
            <h4>Smart</h4>
            <h2>Company</h2>
            <p>
              Welcome to I4Smart, your all-in-one payroll solution designed to
              streamline and simplify your payroll processes.{" "}
            </p>
          </div>
        </div>
        {/* <div className="Left">
          <img src={ImgIllustrate} alt="illustrate" />
          <div className="overlay"></div>
          <Swiper
                 spaceBetween={30}
                 centeredSlides={true}
                 autoplay={{
                   delay: 5500,
                   disableOnInteraction: false,
                 }}
                 pagination={{
                   clickable: true,
                 }}
                 navigation={false}
                 modules={[Autoplay, Pagination]}
                 className="mySwiper"
               >
                 <SwiperSlide>
                  <div className="img1"></div>
                 </SwiperSlide>
                 <SwiperSlide>
                 <div className="img2"></div>
                 </SwiperSlide>
                 <SwiperSlide><div className="img3"></div></SwiperSlide>
               </Swiper>
          <img src={Illustrate} alt="i4smart" />
        </div> */}
        <div className="Right">
          {/* {step ===1 && <LoginDetail/>}
               {step ===2 && <ChangePassword/>}
               {step ===3 && <SetUpDetailPage/>} */}
          <LoginDetail />
          <img src={i4} alt="avatar" />
        </div>
      </div>
    </Fragment>
  );
};

export default LogInPage;
